import {merge} from '#core/utils/config-utils.js';

import {generatePivotsRow} from '#core/application/modules/tiles/pivot/index.js';
import {generateEmptyContentMessage} from '#core/application/modules/tiles/empty-content-message/index.js';

import nflTeamsMap from './nfl-teams.json';

export function sportsContentFactory(PALETTE) {
    return {
        // for racing pages
        SportTabSelector: {
            tabs: merge(generatePivotsRow(PALETTE.SPORT_TABS_PIVOT), {
                itemLabel: {
                    style: {
                        padding: '1px 0',
                    },
                },
                style: {
                    container: {
                        margin: '0px 0px 8px',
                        boxShadow: PALETTE.SPORT_TABS_CONTAINER_SHADOW,
                    },
                },
            }),
        },
        InPlayPage: {
            emptyContent: generateEmptyContentMessage(PALETTE.IN_PLAY_PAGE_NO_CONTENT),
        },
        SportCouponPageView: {
            emptyContent: generateEmptyContentMessage(PALETTE.SPORTS_COUPON_PAGE_NO_CONTENT),
        },
        SportPage: {
            emptyContent: generateEmptyContentMessage(PALETTE.SPORT_PAGE_NO_CONTENT),
        },
        SingleLeaguePage: {
            emptyContent: generateEmptyContentMessage(PALETTE.SINGLE_LEAGUE_PAGE_NO_CONTENT),
        },
        // for event cards
        TeamIcon: {
            enabledSports: ['american_football'],
            teamIcons: Object.keys(nflTeamsMap).reduce(
                (reducer, teamId) => ({
                    ...reducer,
                    [teamId]: `teamicons/nfl/${nflTeamsMap[teamId]}.svg`,
                }),
                {}
            ),
        },
    };
}
